/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateResellerRequest
 */
export interface CreateResellerRequest {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    invoiced?: boolean;
    /**
     * 
     */
    spNewPricing?: boolean;
}

/**
 * Check if a given object implements the CreateResellerRequest interface.
 */
export function instanceOfCreateResellerRequest(value: object): value is CreateResellerRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateResellerRequestFromJSON(json: any): CreateResellerRequest {
    return CreateResellerRequestFromJSONTyped(json, false);
}

export function CreateResellerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateResellerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'invoiced': json['invoiced'] == null ? undefined : json['invoiced'],
        'spNewPricing': json['spNewPricing'] == null ? undefined : json['spNewPricing'],
    };
}

export function CreateResellerRequestToJSON(json: any): CreateResellerRequest {
    return CreateResellerRequestToJSONTyped(json, false);
}

export function CreateResellerRequestToJSONTyped(value?: CreateResellerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'invoiced': value['invoiced'],
        'spNewPricing': value['spNewPricing'],
    };
}

